<header class="navbar">
  <a class="navbar__brand" routerLink="/" aria-label="{{ appName }} home">
    <span class="navbar__mark" aria-hidden="true"><i></i><i></i></span>
    <span>{{ appName }}</span>
  </a>
  <nav class="navbar__links" aria-label="Main navigation">
    <a routerLink="/">{{ copy().home }}</a>
    <a routerLink="/blog">{{ copy().blog }}</a>
    <a routerLink="/about">{{ copy().about }}</a>
    <div [class]="headerClasses.pagesMenu" [class.open]="pagesOpen()">
      <button
        class="navbar__menu-trigger"
        type="button"
        (click)="$event.stopPropagation(); togglePages()"
        [attr.aria-expanded]="pagesOpen()"
        aria-haspopup="true"
      >
        {{ copy().pages }}
        <svg
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
          style="margin-top: 1px"
        >
          <path
            d="M3 5l4 4 4-4"
            stroke="#4B5563"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></path>
        </svg>
      </button>
      @if (pagesOpen()) {
        <div class="navbar__dropdown">
          <span class="navbar__dropdown-label">{{ copy().alternatives }}</span>
          <a routerLink="/omegle-alternative" (click)="closePages()"
            >Omegle alternative</a
          >
          <a routerLink="/ometv-alternative" (click)="closePages()"
            >OmeTV alternative</a
          >
          <a routerLink="/chatroulette-alternative" (click)="closePages()"
            >Chatroulette alternative</a
          >
          <a routerLink="/emerald-chat-alternative" (click)="closePages()"
            >Emerald Chat alternative</a
          >
          <a routerLink="/monkey-app-alternative" (click)="closePages()"
            >Monkey App alternative</a
          >
          <span class="navbar__dropdown-label">{{ copy().explore }}</span>
          <a routerLink="/chat-with-strangers" (click)="closePages()"
            >Chat with strangers</a
          >
          <a routerLink="/random-chat" (click)="closePages()">Random chat</a>
          <a routerLink="/anonymous-chat" (click)="closePages()"
            >Anonymous chat</a
          >
          <a routerLink="/make-friends-online" (click)="closePages()"
            >Make friends online</a
          >
          <a routerLink="/safety-tips" (click)="closePages()">Safety tips</a>
        </div>
      }
    </div>
  </nav>
  <div class="navbar__actions">
    <div class="language-menu">
      <button
        class="navbar__language-trigger"
        type="button"
        (click)="$event.stopPropagation(); toggleLanguage()"
        [attr.aria-expanded]="languageOpen()"
        aria-haspopup="listbox"
      >
        {{ copy().language }}
        <svg
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
          style="margin-top: 1px"
        >
          <path
            d="M3 5l4 4 4-4"
            stroke="#4B5563"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></path>
        </svg>
      </button>
      @if (languageOpen()) {
        <div
          class="navbar__dropdown language-dropdown"
          role="listbox"
          aria-label="Choose language"
        >
          @for (option of languageService.options; track option.code) {
            <button
              type="button"
              role="option"
              [attr.aria-selected]="languageService.language() === option.code"
              [class.selected]="languageService.language() === option.code"
              (click)="selectLanguage(option.code)"
            >
              <span>{{ option.nativeLabel }}</span
              ><small>{{ option.label }}</small>
            </button>
          }
        </div>
      }
    </div>
    <button
      class="navbar__search"
      type="button"
      (click)="$event.stopPropagation(); openSearch()"
      aria-label="Search {{ appName }}"
    >
      &#8981;
    </button>
    <button class="navbar__cta" type="button" (click)="chat()">
      {{ copy().startChat }}
    </button>

    <button
      [class]="headerClasses.mobileToggle"
      type="button"
      aria-label="Open navigation menu"
      (click)="toggleMobileMenu()"
      [attr.aria-expanded]="mobileMenuOpen()"
    >
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <rect y="4" width="24" height="2.5" rx="1.25" fill="#1A1A2E"></rect>
        <rect y="11" width="24" height="2.5" rx="1.25" fill="#1A1A2E"></rect>
        <rect y="18" width="24" height="2.5" rx="1.25" fill="#1A1A2E"></rect>
      </svg>
    </button>
  </div>
</header>
@if (mobileMenuOpen()) {
  <nav class="mobile-nav" aria-label="Mobile navigation">
    <div class="mobile-panel">
      <div class="mobile-panel-header">
        <div class="mobile-brand">
          <span class="mobile-brand-mark" aria-hidden="true"></span>
          <span>{{ appName }}</span>
        </div>
        <button
          type="button"
          class="mobile-panel-close"
          aria-label="Close navigation"
          (click)="closeMobileMenu()"
        >
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
            <path
              d="M5 5L19 19M19 5L5 19"
              stroke="#1A1A2E"
              stroke-width="2.2"
              stroke-linecap="round"
            />
          </svg>
        </button>
      </div>

      <div class="mobile-search-wrap">
        <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <circle
            cx="11"
            cy="11"
            r="6.5"
            stroke="currentColor"
            stroke-width="2"
          ></circle>
          <path
            d="M16 16L21 21"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
          ></path>
        </svg>
        <input
          type="search"
          aria-label="Search pages"
          placeholder="Search"
          [ngModel]="query()"
          (ngModelChange)="query.set($event)"
        />
      </div>

      <div class="mobile-nav-list">
        <a routerLink="/" (click)="closeMobileMenu()">{{ copy().home }}</a>
        <a routerLink="/blog" (click)="closeMobileMenu()">{{ copy().blog }}</a>
        <a routerLink="/about" (click)="closeMobileMenu()">{{
          copy().about
        }}</a>
      </div>

      <div class="mobile-nav-group">
        <span class="mobile-nav-label">{{ copy().alternatives }}</span>
        <a routerLink="/omegle-alternative" (click)="closeMobileMenu()"
          >Omegle alternative</a
        >
        <a routerLink="/ometv-alternative" (click)="closeMobileMenu()"
          >OmeTV alternative</a
        >
        <a routerLink="/chatroulette-alternative" (click)="closeMobileMenu()"
          >Chatroulette alternative</a
        >
        <a routerLink="/emerald-chat-alternative" (click)="closeMobileMenu()"
          >Emerald Chat alternative</a
        >
        <a routerLink="/monkey-app-alternative" (click)="closeMobileMenu()"
          >Monkey App alternative</a
        >
      </div>

      <a class="mobile-view-all" routerLink="/pages" (click)="closeMobileMenu()"
        >View All Pages →</a
      >

      <div class="mobile-language-block">
        <span class="mobile-nav-label">LANGUAGE</span>
        <div class="mobile-language-grid">
          @for (option of languageService.options; track option.code) {
            <button
              type="button"
              class="language-chip"
              [class.active]="languageService.language() === option.code"
              (click)="selectLanguage(option.code)"
            >
              {{ option.nativeLabel }}
            </button>
          }
        </div>
      </div>
    </div>
  </nav>
}
@if (searchOpen()) {
  <div class="search-backdrop" (click)="closeSearch()">
    <section
      class="search-dialog"
      role="dialog"
      aria-modal="true"
      aria-labelledby="search-title"
      (click)="$event.stopPropagation()"
    >
      <div class="search-dialog-head">
        <h2 id="search-title">{{ copy().searchTitle }}</h2>
        <button
          type="button"
          class="dialog-close"
          (click)="closeSearch()"
          aria-label="Close search"
        >
          ×
        </button>
      </div>
      <input
        class="search-input"
        type="search"
        [placeholder]="copy().searchPlaceholder"
        aria-label="Search pages and guides"
        [ngModel]="query()"
        (ngModelChange)="query.set($event)"
        autofocus
      />
      <div class="search-results">
        @for (result of results(); track result.url) {
          <a
            class="search-result"
            [routerLink]="result.url"
            (click)="closeSearch()"
          >
            <span class="result-type">{{ result.type }}</span>
            <strong>{{ result.title }}</strong>
            <small>{{ result.description }}</small>
          </a>
        } @empty {
          <p class="search-empty">{{ copy().emptySearch }}</p>
        }
      </div>
    </section>
  </div>
}
